var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPartnerAlpineresorts(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "partner_alpineresorts_svg__b",
    x1: 21.39,
    y1: 250,
    x2: 474.26,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b83121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#be4826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c04e28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "partner_alpineresorts_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.74 122.55h455.53l1.34 254.9-457.22-.09.35-254.81z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#partner_alpineresorts_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.2 188.71l4.57-5.89 46.22 53.42 77.24-112.82c-9.58-.53-19.24-.88-29.08-.88-126.53 0-223.8 45.16-226.17 67.48l-1.41 167.83c36.2-48.68 127.58-167.92 128.64-169.15m324.06.97c-1.85-19.24-77.68-55.88-178.64-65.02l177.41 232.68 1.23-167.65zm-195.77-9.49l12.57-11.77 82.42 107.46-8.08 7.03-23.9-21.88-21.97 19.42 13.44-27.59-32.07 19.07 20.91-32.16-35.76 20.65 23.81-31.46-38.93 24.69 24.16-37.96-37.7 23.55 32.34-41.74-11.25-17.31zM153.55 317.34l20.47-53.86-32.51 26.98 20.56-56.5c2.64.79 31.98 30.4 31.98 30.4l-40.51 52.98zm48.33-60.89l-6.33-7.29-40.6-46.75s-68.19 89.1-68.19 89.27l-65.37 85.68 38.22-9.93a815.431 815.431 0 01187.77-21.88c62.37 0 124.53 7.26 185.23 21.62 13.27 3.25 25.75 6.68 37.7 10.28L286.49 133.09l-77.5 113.26-7.12 10.1z",
    fill: "url(#partner_alpineresorts_svg__b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerAlpineresorts);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "a81e19806853b209c015107e1db99b32.svg";
export { MemoForwardRef as ReactComponent };